import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { IonRouterOutlet, IonSearchbar, ModalController } from '@ionic/angular';
import { IDaireBorcAlacak } from '@models/finance';
import { FinanceService } from '@services/apis/finance.service';
import { RootModalComponent } from '@shared/components/root-modal/root-modal.component';
import { DaireBorcAlacakDetailComponent } from '../../finance/daire-borc-alacak-detail/daire-borc-alacak-detail.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit {
  @ViewChild(IonSearchbar, { static: true }) searchKey: IonSearchbar;
  public hesapDaireArama: IDaireBorcAlacak[];
  public searchControl: string;

  constructor(
    private financeService: FinanceService,
    private modalController: ModalController,
    private routerOutlet: IonRouterOutlet,
  ) { }

  ngOnInit(): void {
    this.getHesapDaireArama();
  }

  ionViewDidEnter() {
    this.searchKey.setFocus();
  }

  getHesapDaireArama() {
    this.financeService.getDaireBorcAlacak$().subscribe(response => {
      this.hesapDaireArama = response;
    });
  }

  search(event: Event): void {
    const filter = (event.target as HTMLInputElement).value;
    this.searchControl = filter;
  }

  async detail(daireBorcAlacak: IDaireBorcAlacak) {
    const modal = await this.modalController.create({
      component: RootModalComponent,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        rootPage: DaireBorcAlacakDetailComponent,
        daireBorcAlacak,
      }
    });
    return await modal.present();
  }
}
